import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  // Marking Controls
  markAllAsTouched(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllNotEmptyAsTouched(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.get(key);
      if (
        control?.value !== undefined &&
        control?.value !== null &&
        control?.value?.length !== 0
      ) {
        if (control instanceof FormControl) {
          control.markAsTouched();
          control.markAsDirty();
        } else if (
          control instanceof FormGroup ||
          control instanceof FormArray
        ) {
          this.markAllAsTouched(control);
        }
      }
    });
  }

  markAllAsUntouched(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.get(key);
      if (control instanceof FormControl) {
        control.markAsUntouched();
        control.markAsDirty();
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllAsUntouched(control);
      }
    });
  }

  // Input Validation
  validateNumber(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    inputElement.value = inputValue.replace(/[^0-9]/g, '');
  }

  onInputForNumberField(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  onInputForNumberField2(event: Event, control: AbstractControl | null): void {
    if (!control) return;

    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.replace(/[^0-9]/g, '');

    control.setValue(inputValue, { emitEvent: false });
    control.updateValueAndValidity({ emitEvent: false });
  }

  // Formatting
  formatZipCode(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value;

    inputValue = inputValue.replace(/[^0-9-]/g, '');

    if (inputValue.length > 2 && inputValue.charAt(2) !== '-') {
      inputValue = inputValue.slice(0, 2) + '-' + inputValue.slice(2);
    }

    if (inputValue.length > 6) {
      inputValue = inputValue.slice(0, 6);
    }

    inputElement.value = inputValue;
  }

  formatAmount(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value;

    inputValue = inputValue.replace(/,/g, '.');
    inputValue = inputValue.replace(/[^0-9.]/g, '');

    if (inputValue.startsWith('.')) {
      inputValue = inputValue.slice(1);
    }

    const decimalIndex = inputValue.indexOf('.');
    if (decimalIndex !== -1) {
      inputValue =
        inputValue.slice(0, decimalIndex + 1) +
        inputValue.slice(decimalIndex + 1, decimalIndex + 3).replace(/\./g, '');
    }

    inputElement.value = inputValue;
  }
}
